import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const faqs = [
    {
      question: "É gratuito?",
      answer: "Sim, durante o Beta (vagas limitadas). Queremos ajustar o produto com base no seu uso real antes do lançamento oficial."
    },
    {
      question: "Substitui advogado/cartório?",
      answer: "Não. É material informativo; recomenda-se validação jurídica/cartorial para decisões finais."
    },
    {
      question: "Casos complexos?",
      answer: "Podem requerer documentos extras ou ficar em fila. Priorizamos casos mais diretos durante o Beta."
    },
    {
      question: "Tem limite de uso?",
      answer: "Sim: 1 Laudo + 1 Flash por CB no período do Beta. Isso garante que todos possam testar."
    },
    {
      question: "O que ganho participando?",
      answer: "Economia de tempo + acesso prioritário no lançamento + influência direta no desenvolvimento do produto."
    },
    {
      question: "Como envio documentos?",
      answer: "Pelo WhatsApp: link do edital e/ou matrícula (PDF/URL), cidade/UF, estratégia do cliente e prazo."
    }
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white" id="faq">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900">
            FAQ - Beta Aberto
          </h2>
          <p className="text-xl text-slate-600">
            Tire suas dúvidas sobre como participar do Beta gratuito
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`mb-4 border rounded-lg transition-all duration-300 ${
                openIndex === index ? 'border-blue-300 bg-white shadow-md' : 'border-slate-200 bg-white'
              }`}
            >
              <button
                className="w-full text-left p-6 focus:outline-none flex justify-between items-center"
                onClick={() => toggleFaq(index)}
                aria-expanded={openIndex === index}
              >
                <h3 className="text-xl font-semibold text-slate-900">{faq.question}</h3>
                {openIndex === index ? (
                  <ChevronUp className="h-5 w-5 text-blue-600 flex-shrink-0" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-slate-600 flex-shrink-0" />
                )}
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-slate-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200 max-w-2xl mx-auto">
            <p className="text-yellow-800 font-medium">
              ⚖️ <strong>Aviso legal:</strong> ImóvelIA é um assistente de análise. Não substitui assessoria jurídica/cartorial. Estimativas informativas.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;